import React, { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import { useTranslate } from "../../helpers";
import AppPage from "../../components/AppPage";
import routes from "../../app/routes";

const PlanDetailsErrorPage: FunctionComponent = () => {
  const t = useTranslate();
  return (
    <div style={{ marginBottom: "144px" }} className="ds-u-margin-top--4">
      <AppPage heading={t("plan_details.error_retrieving.heading")}>
        <span>{t("plan_details.error_retrieving.message")}</span>{" "}
        <Link to={routes.searchResults}>
          {t("plan_details.error_retrieving.link")}
        </Link>
        .
      </AppPage>
    </div>
  );
};

export default PlanDetailsErrorPage;
